var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"person-container"},[_c('span',{staticClass:"person-name-text"},[_vm._v(_vm._s(_vm.member.name))]),_c('button',{staticClass:"remove-person-button",on:{"click":_vm.removeMember}},[_vm._v("X")])])
}
var staticRenderFns = []

export { render, staticRenderFns }